import { GANTT_LAYOUT_PRESETS } from "@/ds";
import { Gantt, lanesMinHeightRem } from "@/shared/components/gantt";
import type { GanttColumn } from "@/shared/components/gantt";

import { AllocationBar } from "@/shared/components/gantt-allocation-bar";
import baseStyles from "@/shared/components/gantt-carga/gantt.module.scss";
import {
  LAYOUT_PRESET,
  MONTH_MIN_WIDTH,
  ROW_MIN_HEIGHT_REM,
  ROW_PADDING_REM,
} from "./revisao-gantt.constants";
import styles from "./revisao-gantt.module.scss";
import type { RevisaoGanttViewModel } from "./types-revisao-gantt";

const COLUMNS: GanttColumn[] = [
  { key: "local", header: "Local", width: "var(--gantt-left)", cellClassName: baseStyles.leftCell },
];

export function RevisaoGanttView({ rows, scale, today, destaque }: RevisaoGanttViewModel) {
  return (
    <Gantt.Root
      className={styles.ganttRoot}
      scale={scale}
      today={today}
      columns={COLUMNS}
      grid="none"
      withActions
      unitMinWidth={MONTH_MIN_WIDTH}
      rows={rows.map((row) => ({
        key: row.key,
        testId: "gantt-row-revisao",
        minHeight: `${lanesMinHeightRem({
          lanes: row.lanes,
          laneHeightRem: GANTT_LAYOUT_PRESETS[LAYOUT_PRESET].laneHeightRem,
          paddingRem: ROW_PADDING_REM,
          minRem: ROW_MIN_HEIGHT_REM,
        })}rem`,
        actionLabel: `Detalhes de ${row.title}`,
        cells: [
          <span key="t" className={baseStyles.rowTitle}>
            {row.title}
          </span>,
        ],
        content: (
          <>
            {destaque ? (
              <span
                className={baseStyles.conflictBandIgnored}
                style={{ left: `${destaque.left}%`, width: `${destaque.width}%` }}
                data-testid="gantt-highlight-band"
              />
            ) : null}
            {row.items.map((item) => (
              <AllocationBar key={item.key} item={item} layout={LAYOUT_PRESET} />
            ))}
          </>
        ),
      }))}
    />
  );
}
